import React from 'react';

// import pick from 'lodash/pick';
import { TabPane, Tabs } from '@element/index';
// import { SymbolState } from '@type/market';
import I18n from '@utils/i18n'
import KLine from '@widget/trade/KLine'

// import { AskHeader, BaseOrderBook, Header, useHeader } from '../BaseOrderBook';
// import { H5BtnGroup } from '../BuyAndSell'
import { KLineHeader } from '../KLineHeader';

import styles from './index.module.css';

export const KLineH5 = (props) => {
  // const { updateRiseFallIcon, riseFallIcon } = useHeader();
  // const allowTrade = useMemo(() => {
  //   return props?.tradeCoinDetail?.allowTrade && props?.tradeCoinDetail?.state !== SymbolState.EXPLORE
  // }, [props?.tradeCoinDetail]);
  return (
    <section className={styles.wrapper}>
      <KLineHeader className={styles.header} {...props.kLineHeaderProps} />
      <Tabs type="primary" className={styles.tabs}>
        <TabPane tab={I18n.t('XDffEWxe')} key="1" type="primary">
          <KLine coinCode={props.coinCode} precision={props.precision} />
        </TabPane>
        {/* {!isNewUser && allowTrade &&
          <TabPane tab={I18n.t('orderBook')} key="2" type="primary" className={styles.orderbook}>
            <BaseOrderBook
              {...pick(props, 'bids', 'asks')}
              coinDetail={props.tradeCoinDetail}
              type="h5"
              riseFallIcon={riseFallIcon}
              askHeader={<AskHeader quoteCurrency={props?.coinArr?.[1]} />}
              bidHeader={<AskHeader quoteCurrency={props?.coinArr?.[1]} className={styles.bidHeader} />}
              header={<Header updateRiseFallIcon={updateRiseFallIcon} riseFallIcon={riseFallIcon} />}
            />
          </TabPane>
        } */}
      </Tabs>
      {/* {!isNewUser && allowTrade && <H5BtnGroup baseCurrency={props?.coinArr?.[0]} coinDetail={props.tradeCoinDetail} quoteCurrency={props?.coinArr?.[1]} />} */}
    </section>
  );
}
